import { render, staticRenderFns } from "./SelectRelation.vue?vue&type=template&id=958f15fc"
import script from "./SelectRelation.vue?vue&type=script&lang=js"
export * from "./SelectRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports